<template>
    <div>
        <div class="ma-5 text-center" v-if="isLoading">
            <v-progress-circular class="mt-8" indeterminate :width="2"></v-progress-circular>
        </div>
        <v-form v-on:submit.prevent="submit" ref="form" v-else>
            <v-card outlined elevation="0" class="mb-4">
                <v-tabs v-model="tab" grow>
                    <v-tab v-for="lang in tenant.languages" :key="'langtab-' + lang.code">
                        <img :src="lang.icon" style="max-height: 20px" />
                        &nbsp;&nbsp;{{ lang.name }}
                        &nbsp;
                        <v-icon v-if="langOk(group.translations, lang.code, [
                            'name',
                        ])
                        " color="success">
                            {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon v-else color="error">
                            {{ icons.mdiBlockHelper }}
                        </v-icon>
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item v-for="lang in tenant.languages" :key="'langtabitem-' + lang.code">
                        <div class="px-5 py-10">

                            <v-text-field :id="'group-title-' + lang.code" v-model="group.translations[lang.code].name"
                                :label="$t('Ryhmän nimi')" outlined class="mb-4" hide-details="auto"
                                :rules="[required]" />


                            <v-switch v-model="group.is_active" :label="$t('Käytössä')" persistent-hint :hint="group.is_active
                                ? $t('Ryhmä on käytössä')
                                : $t('Ryhmä ei ole käytössä')
                                ">
                            </v-switch>
                            <v-alert v-if="!group.is_active" color="info" text class="mt-3">
                                <div style="white-space: pre-line;">
                                    {{ $t('DisableGroupInfo') }}
                                </div>
                            </v-alert>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
                <v-card-text class="mt-0 pt-0">
                    <v-input class="mb-3" hidden hide-details="auto" :rules="[validateLangs]"></v-input>

                    <v-btn type="submit" color="primary">{{ $t('Tallenna') }}</v-btn>
                    <v-alert v-if="errors.length" type="error" class="mt-2">
                        <div v-for="error in errors" style="white-space: pre-line;">
                            {{ error }}
                        </div>
                    </v-alert>
                </v-card-text>
            </v-card>
        </v-form>
    </div>
</template>

<script>
import { getValidTranslations, langOk } from '@/@core/utils/translation_helpers';
import useAuth from '@/useAuth';
import { onMounted, reactive, ref } from '@vue/composition-api';
import { mdiCheck, mdiBlockHelper } from '@mdi/js';
import { i18n } from '@/plugins/i18n';
import adminApi from '@/api/admin';
import { required } from '@/@core/utils/validation';
import { getResponseErrors } from '@/@core/utils/get_response_errors';

export default {
    props: ["id"],
    setup(props, { emit }) {
        const { tenant } = useAuth();
        const tab = ref(null);
        const form = ref(null);
        const isLoading = ref(false);
        const errors = ref([]);

        const group = reactive({
            id: null,
            translations: {},
            is_active: true,
        });

        tenant.value.languages.forEach((lang) => {
            group.translations[lang.code] = {
                name: "",
            };
        });

        const getGroup = async (id) => {
            isLoading.value = true;
            const response = await adminApi.getGroup(id);
            if (response.ok) {
                group.id = response.data.id;
                group.is_active = response.data.is_active;
                group.translations = {};
                tenant.value.languages.forEach((lang) => {
                    if (response.data.translations[lang.code]) {
                        group.translations[lang.code] = response.data.translations[lang.code];
                    } else {
                        group.translations[lang.code] = {
                            name: "",
                        };
                    }
                });
            }
            else {
                alert(response.error);
            }
            isLoading.value = false;
        }

        const submit = async () => {
            errors.value = []
            var valid = form.value.validate();
            if (valid) {
                const saveGroupRequest = Object.assign({}, group);

                // Translations
                saveGroupRequest.translations = getValidTranslations(group.translations, [
                    "name",
                ]);

                var res = await adminApi.saveGroup(saveGroupRequest);
                if (res.ok) {
                    emit('saved', res.data.id);
                } else {
                    errors.value = getResponseErrors(JSON.parse(res.error));
                }
            }
        }



        onMounted(() => {

            if (props.id) {
                getGroup(props.id);
            }
        });

        const validateLangs = () => {
            let valid = true;
            tenant.value.languages.forEach((lang) => {
                if (!langOk(group.translations, lang.code, ["name"]))
                    valid = false;
            });

            if (valid) {
                return true;
            } else {
                return i18n.t("Nimi on pakollinen kaikilla kielillä");
            }
        };

        return {
            tab,
            form,
            group,
            tenant,
            validateLangs,
            langOk,
            isLoading,
            submit,
            required,
            errors,
            icons: {
                mdiCheck,
                mdiBlockHelper
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
